module.exports = __webpack_public_path__ + "assets/img/dzh-15.5890aefb.gif";